const DEFAULTS = {
}

export default class CustomCheckbox {

  constructor (el, options) {
    this.options = options;
    // Assuming contact form 7, and follow the same structure
    this.$wrapper = $(el)
    this.$label = this.$wrapper.find('label').first()
    this.$el = this.$wrapper.find('input[type="checkbox"]').first()
    this.init();
  }

  /**
   * Register this component as global jquery plugin
   */
  static jqueryPlugin () {
    $.fn.customCheckbox = function (option) {
        var args = Array.prototype.slice.call(arguments, 1)
        return this.each(function () {
            var $this   = $(this)
            var data    = $this.data('trueper.custom-checkbox')
            var options = $.extend({}, DEFAULTS, $this.data(), typeof option == 'object' && option)
            if (!data) $this.data('trueper.custom-checkbox', (data = new CustomCheckbox(this, options)))
            else if (typeof option == 'string') data[option].apply(data, args)
        })
    }
    $.fn.customCheckbox.Constructor = CustomCheckbox
    $('.custom-checkbox').customCheckbox();
  }

  init () {
    this.$el.on('change', () => {
      this.check()
    })
  }

  check () {
    if (this.$el.is(':checked')) {
      this.$wrapper.addClass('is-active')
    } else {
      this.$wrapper.removeClass('is-active')
    }
  }

}



// WEBPACK FOOTER //
// ./scripts/components/custom-checkbox.js